import { sessionConstants } from '../constants';

export function natureIssue (state = {}, action) {
    switch (action.type) {
      case sessionConstants.SESSION_NATURE_OF_ISSUE_REQUEST:
        return { 
          loading:action.res
         };
      case sessionConstants.SESSION_NATURE_OF_ISSUE_SUCCESS:
      return {
          ...state,
          natureIssue: action.res,
          loading:false,
        };
      case sessionConstants.SESSION_STATUS_FAILURE:
        return {
          error: action.error,
          loading:false
        };
      default:
        return state
    }
  }


// WEBPACK FOOTER //
// ./src/store/reducers/natureIssue.reducer.js